import '.i8{border-radius:0.625rem 0 0 0.625rem;}.ssr-plugin'
import '.i9{border-block:var(--border-default);}.ssr-plugin'
import '.ia{border-left:var(--border-default);}.ssr-plugin'
import '.ib{border-right:0px;}.ssr-plugin'
import '.p{padding:0px;}.ssr-plugin'
import '.z{cursor:pointer;}.ssr-plugin'
import '.fc{background:none;}.ssr-plugin'
import '.ic{border-radius:0 0.625rem 0.625rem 0;}.ssr-plugin'
import '.id{border-right:var(--border-default);}.ssr-plugin'
import '.ie{border-left:0px;}.ssr-plugin'
import { Text } from '@app/components/core/typography/Text'
import Row from '@app/components/layout/Row'
import { faMinus, faPlus } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Style, styled } from 'inlines'
import { InputField } from '../InputField'

export type AmountPickerProps = {
  label: string
  value: number
  setValue: React.Dispatch<React.SetStateAction<number>>
  min?: number
  max?: number
}

const commonStyles: Style = {
  width: '2.6875rem',
  height: '2.6875rem',
  display: 'flex',
  flex: '1',
  justifyContent: 'center',
  alignItems: 'center',
}

export const AmountPicker = ({
  value,
  label,
  min = 0,
  max = 10,
  setValue,
}: AmountPickerProps) => {
  const decrease = () => {
    if (value > min) {
      setValue((prev) => prev - 1)
    }
  }
  const increase = () => {
    if (value < max) {
      setValue((prev) => prev + 1)
    }
  }
  return (
    <InputField label={label}>
      <Row style={{ width: '8.0625rem' }} gap={0}>
        <styled.button className="i8 i9 ia ib p z fc"
          onClick={decrease}
          style={{
            ...commonStyles,}}
        >
          <FontAwesomeIcon icon={faMinus} />
        </styled.button>
        <Text.Medium
          style={{
            ...commonStyles,
            border: 'var(--border-default)',
            userSelect: 'none',
          }}
        >
          {value}
        </Text.Medium>
        <styled.button className="ic i9 id ie p z fc"
          onClick={increase}
          style={{
            ...commonStyles,}}
        >
          <FontAwesomeIcon icon={faPlus} />
        </styled.button>
      </Row>
    </InputField>
  )
}
